import { AlertsActionTypes, IAlertsState } from "./types";

export const initialState: IAlertsState = {
  message: '',
  visible: false,
};

export const alertReducer = (state: IAlertsState, action: any): IAlertsState => {
  switch (action.type) {
    case AlertsActionTypes.SHOW_ALERT:
      return {
        ...state,
        ...action.payload,
        visible: true,
      };
    case AlertsActionTypes.HIDE_ALERT:
      return {
        ...state,
        visible: false,
      };
    default:
      return state;
  }
};

